import { Link } from 'react-router';
import { Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <h1 className="text-6xl font-bold text-surface-inset">404</h1>
      <p className="mt-4 text-lg text-text-secondary">{t('web:notFoundPage.pageNotFound')}</p>
      <Link
        to="/dashboard"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
      >
        <Home className="h-4 w-4" />
        {t('web:notFoundPage.goToDashboard')}
      </Link>
    </div>
  );
}
